import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SchedulePeriod } from '../models/schedulePeriod';
import { AdminStats } from '../models/adminStats';
import { ServiceBase } from './service-base.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService extends ServiceBase {

  protected override get serviceDomain(): string {
    return 'admin';
  }
    
  getAdminStats(): Observable<AdminStats> {
    return this.httpClient.get<AdminStats>(`${this.baseUrl}/stats`);
  }

  getRecentSchedulePeriods(limit: number): Observable<SchedulePeriod[]> {
    return this.httpClient.get<SchedulePeriod[]>(`${this.baseUrl}/schedule-periods/recent`, {
      params: { limit: limit.toString() }
    });
  }

  getKnowledgeBaseByOrganization(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseUrl}/knowledge-base-by-organization`);
  }


  provisionSmallTalk(organizationId: string): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/provision-small-talk`, {}, { params: { organizationId } });
  }


  //=============Import/Export TSV

  generateTsv(organizationId: string): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/${organizationId}/generate-tsv`, null, { responseType: 'blob'});
  }

  importTsv(organizationId: string, file: File, importType: 'SmallTalk' | 'Web' | 'Phone'): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post(`${this.baseUrl}/${organizationId}/import-tsv?importType=${importType}`, formData);
  }

  //=============


  //=============Integrrate TSV
  integrateAQA(organizationId: string, importType: 'SmallTalk' | 'Web' | 'Phone'): Observable<any> {
    return this.httpClient.post<void>(`${this.baseUrl}/${organizationId}/update-aqa`, {}, { params: { importType } });
  }
  //=============


  //==============Generate Intent Map XML

  generateIntentMapForOrganization(organizationId: string): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/${organizationId}/generate-intentMap`, null, { responseType: 'blob'});
  }

  integrateIntentMap(organizationId: any, type: 'web' | 'phone'): Observable<any> {
    return this.httpClient.post<void>(`${this.baseUrl}/${organizationId}/integrate-intentMap`, { type });
  }

  //=================================


  //===========================Apply data to environment
  applyDataToEnvironment(organizationId: string, environmentId: string, environment: 'dev' | 'test' | 'prod'): Observable<any> {

    return this.httpClient.post(`${this.baseUrl}/${organizationId}/apply-data-to-environment`, null, { params: { environment } });
  }


}
